import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from 'lucide-react';
import { useBusiness } from '@/lib/business';
import { Container } from './ui/Container';

export function Footer() {
  const SITE = useBusiness();
  return (
    <footer className="bg-espresso-deep text-cream">
      <Container className="py-16">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="wordmark text-4xl text-gold">{SITE.wordmark}</p>
            <p className="font-body text-[10px] font-medium uppercase tracking-[0.4em] text-cream/80">Spa · Stays · Car Hire</p>
            <div className="rule-gold mt-4" />
            <p className="mt-4 max-w-xs font-body text-sm leading-relaxed text-cream/70">{SITE.subTagline}.</p>
            <div className="mt-5 flex gap-4">
              <a href={SITE.social.instagram} aria-label="Instagram" className="text-cream/70 hover:text-gold"><Instagram size={20} /></a>
              <a href={SITE.social.facebook} aria-label="Facebook" className="text-cream/70 hover:text-gold"><Facebook size={20} /></a>
            </div>
          </div>

          <div>
            <p className="eyebrow mb-4 text-gold-soft">Explore</p>
            <ul className="space-y-2.5 font-body text-sm text-cream/70">
              <li><Link to="/services" className="hover:text-gold">Treatments</Link></li>
              <li><Link to="/booking" className="hover:text-gold">Booking</Link></li>
              <li><Link to="/gallery" className="hover:text-gold">Gallery</Link></li>
              <li><Link to="/stay" className="hover:text-gold">Stay with us</Link></li>
              <li><Link to="/cars" className="hover:text-gold">Car Hire</Link></li>
              <li><Link to="/about" className="hover:text-gold">About</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-4 text-gold-soft">Visit</p>
            <ul className="space-y-3 font-body text-sm text-cream/70">
              <li className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-gold" />{SITE.address}</li>
              <li className="flex gap-3"><Phone size={16} className="mt-0.5 shrink-0 text-gold" /><a href={`tel:${SITE.phoneDial}`} className="hover:text-gold">{SITE.phone}</a></li>
              <li className="flex gap-3"><Mail size={16} className="mt-0.5 shrink-0 text-gold" /><a href={`mailto:${SITE.contactEmail}`} className="hover:text-gold">{SITE.contactEmail}</a></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-4 text-gold-soft">Hours</p>
            <ul className="space-y-3 font-body text-sm text-cream/70">
              {SITE.hours.map((h) => (
                <li key={h.day} className="flex gap-3">
                  <Clock size={16} className="mt-0.5 shrink-0 text-gold" />
                  <span><span className="block text-cream/90">{h.day}</span>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-cream/10 pt-8 sm:flex-row">
          <p className="font-body text-xs text-cream/50">© {new Date().getFullYear()} {SITE.legalName}. {SITE.city}, {SITE.country}.</p>
          <p className="font-body text-xs italic text-cream/50">{SITE.tagline}</p>
        </div>
      </Container>
    </footer>
  );
}
